module.exports = __webpack_public_path__ + "img/approval7.b3501fe3.png";